import { render, staticRenderFns } from "./WorkshopsPayment.vue?vue&type=template&id=75c487e4&scoped=true&"
import script from "./WorkshopsPayment.vue?vue&type=script&lang=js&"
export * from "./WorkshopsPayment.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopsPayment.vue?vue&type=style&index=0&id=75c487e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c487e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
